/* template */
<template/>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"md8550214"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "md8550214"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isFirst&isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./index.mpx?ctorType=page&index=0&isFirst&isPage&lang=js&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["md8550214"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"navigationBarTitleText":"","backgroundColor":"#ffffff"},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
